<template>
  <body>
    <div class="invoice_app">
      <div class="invoice_succeed">
        <img src="~@/assets/images/html/success_03.png" alt="" >
      </div>
      <div class="invoice_rem">
        <span>电子普通发票申请已提交!</span><br>
        <span>您可以在订单列表查看发票详情！</span>
      </div>
      <div class="invoice_content">
        <span>发票类型：电子普通发票</span>
        &nbsp;&nbsp;&nbsp;&nbsp;
        <span>发票内容:   {{ this.doc_content }}</span><br>
        <span class="pad">购买方名称： {{ this.head  }}</span><br>
        <div v-if="this.inoviceType == 1">
          <span>纳税人识别号：{{ this.taxpayer_code }}</span><br>
        </div>
        <span>发票金额：￥{{ this.amount }}</span>
        &nbsp;&nbsp;&nbsp;&nbsp;
        <span>申请时间：  {{ $dateUtil.df(this.time, 'YYYY-MM-DD') }}</span>
      </div>
    </div>
    <div class="inp">
        <input type="button" value="关闭" @click="close()">
    </div>
  </body>
</template>
<style scoped>
  .invoice_app{
    padding-left: 8%;
    background: #eee;
    font-family:Microsoft YaHei;
    font-size: 1.5em;
    
  }
  .pad{
    padding-top: 1em;
  }
  .inp{
    text-align: center;
  }
  .inp input {
    background-color: #5595e3;
    width: 90px;
    font-size: 10px;
    padding: 1% 1%;
    color: #fff;
    margin-top: 0.5em;
    text-align: center;
    margin:2em;
  }
  .invoice_content p {
      font-size: 1.5em;
      line-height: 200%;
      text-align: left;
  }
  .invoice_content, .invoice_succeed{
      padding: 2em 0;
  }
  .invoice_succeed  {
      width: 15%;
      vertical-align: middle;
      display: inline-block;
  }
  .invoice_succeed img {
      width: 100%;
  }
  .invoice_rem {
      width: 15%;
      width: 80%;
      line-height: 150%;
      display: inline-block;
      font-weight:bold;
  }
  .succeed_message {
      font-size: 1.5em;
  }
  .succeed_message p {
      width: 80%;
      line-height: 150%;
  }
  .invoice_content span{
    padding-top: 1em;
  }
</style>
<script>
export default {
    data() {
        return{
            amount:'',
            head:'',
            taxpayer_code:'',
            inoviceType:'',
            doc_content:'',
            table_isd:'',
            dateInvoiceDialogVisible:'',
            time: this.getNowTimestamp(),
        }
    },
    created(){
        this.amount = this.$sessionStorageUtil.get('amount')
        this.head = this.$sessionStorageUtil.get('head')
        this.taxpayer_code = this.$sessionStorageUtil.get('taxpayer_code_inp')
        this.doc_content = this.$sessionStorageUtil.get('doc_content')
        this.inoviceType = this.$sessionStorageUtil.get('invoiceBelongType')
        this.table_ids = this.$sessionStorageUtil.get('table_ids')
    },
    methods: {
      getNowTimestamp() {
          return new Date().getTime()
      },
      close() {
        this.$store.dispatch('reloadInvoiceView')
      }
    }
}
</script>



// WEBPACK FOOTER //
// src/pages/common/invoiceAppSucceed.vue